module.exports = __webpack_public_path__ + "static/media/cordillera.afc08b43.PNG";